import React from 'react';
import { AIKawabata } from "./AIKawabata";
import { Player } from "./dynamic";
const Othello = require('othello-game-logic');

const REGISTERS = {
  AIKawabata
};
console.log(REGISTERS);
// let bb='https://leotakeishi.com/js/dynamic.js';
// import(bb);
// console.log(bb);

let cpuPlayerBlack;
let cpuPlayerWhite;
let player;
// dynamic import webpackを通さずクロスオリジンでimportする書き方
let hdata = 'https://leotakeishi.com/js/leo.js';
window.nativeImport(hdata).then(
//import('./dynamic.js').then(
  // defaultとして読み込んだモジュールを「MyModule」という名前空間として、
  // then()のコールバック関数の引数に渡す
  //({ default: MyModule }) => {
  (module) => {
    //console.log(module);
    player = module.Player;
    //let v = new module.default().foo();
    //let v = new module.Player().foo();
    //console.log(new module.default().foo());
    console.log(player.foo(), player);
  }
).catch(err => {
  //  エラー処理
  console.log('エラー',err,err.stacktrace);
});
//

// window.nativeImport(hdata)
// 	.then(module => {
//     player = module.Player;
//     console.log('いえ〜い');
// 	})
// 	.catch(err => {
// 	  console.log(err);
// 	});

// 練習
import('./dynamic.js').then(
//   // defaultとして読み込んだモジュールを「MyModule」という名前空間として、
//   // then()のコールバック関数の引数に渡す
//   //({ default: MyModule }) => {
  (module) => {
//     //console.log(module);
    player = module.Player;
//     //let v = new module.default().foo();
//     //let v = new module.Player().foo();
//     //console.log(new module.default().hoge());
//     console.log(module.Hoge.hogehoge());
    console.log(player.foo());
  }
).catch(err => {
  //  エラー処理
  console.log('エラーどす',err);
});
//

// 練習
import('./module/module.js')
  .then(module => {
    console.log(module.hoge);
  })
  .catch(err => {
    console.log('エラーどす',err);
  });

// クラス構文 練習
// class Square {
//   constructor (width,height) {
//     this.width = width;
//     this.height = height;
//   }

//   result (){
//     return this.width * this.height;
//   }
// }

// function square (width,height) {
//   this.width = width;
//   this.height = height;
// }
// square.prototype.result = function () {
//   return this.width * this.height;
// }
// var square2  = new square(3,9);
// console.log(square2.result());
// クラス構文 練習 ここまで

class Main extends React.Component {

  // playerBlack = {
  //   isAI:false,
  //   getNextCell(state){
  //     let z = state.items.black.placeableCells.length-1;
  //     let c = Math.floor(Math.random () * z);
  //     console.log(c);
  //     return state.items.black.placeableCells[c];
  //   }
  // };

  // playerWhite = {
  //   isAI:false,
  //   getNextCell(state){
  //     let z = state.items.white.placeableCells.length-1;
  //     let c = Math.floor(Math.random () * z);
  //     return state.items.white.placeableCells[c];
  //   }
  // };

  // コンピューターが盤面に石を置くとき
  cpuPutStone() {
    if (this.state.items.gameState=="black") {
      if(this.state.items.black.placeableCells.length!=0){
        let cell =  cpuPlayerBlack.playerBlack.getNextCell(this.state.items);
        this.playerAction(null, cell.x, cell.y);
      } else {
        return false
      }

    } else if (this.state.items.gameState=="white") {
      if(this.state.items.white.placeableCells.length!=0){
        let cell =  cpuPlayerWhite.playerWhite.getNextCell(this.state.items);
        console.log("cell", cell);
        this.playerAction(null, cell.x, cell.y);
      } else {
        return false
      }
    }
  }

  constructor(props){
    super(props);

    this.store = Othello.createStore();

    this.store.subscribe(othelloState => {
      this.setState({
        items: othelloState,
      });

      // CPUの場合は1秒後に自動で石置く
      setTimeout(()=>{
        if(this.state.items.gameState=="white" && player.playerWhite.isAI == true) {
          this.cpuPutStone();
        } else if(this.state.items.gameState=="black" && player.playerBlack.isAI == true) {
          this.cpuPutStone();
        }
      },500);
 

    });

    this.state = {
      items: this.store.getState(),
      playerBlackSetting: '人間',
      playerWhiteSetting: '人間',
      urlBlack: '',
      urlWhite: ''
    };

  }

  // ユーザーが盤面に置くときのonclick
  playerAction(e, x, y) {
    if (this.state.items.gameState=="black") {
      this.state.items.black.placeableCells.find((pcell) => {
        if(pcell.x==x && pcell.y==y) {
          // console.log("dispatch",pcell);
          this.store.dispatch(Othello.ActionCreator.putStone(x, y, this.state.items.gameState));
          return true;
        }
      })
    } else if (this.state.items.gameState=="white") {
      this.state.items.white.placeableCells.find((pcell) => {
        if (pcell.x==x && pcell.y==y) {
          // console.log("dispatch",pcell);
          this.store.dispatch(Othello.ActionCreator.putStone(x, y, this.state.items.gameState));
          return true;
        }
      })
    }
  }


  // player selectboxのonChange
  playerBlackSettingChange(event){
    if (REGISTERS[event.target.value]){
      // player = REGISTERS[event.target.value];
      player.playerBlack.isAI = true;
    } else if(event.target.value === 'CPU'){
      player.playerBlack.isAI = true;
    } else {
      player.playerBlack.isAI = false;
    }
    this.setState({playerBlackSetting: event.target.value});
  }

  playerWhiteSettingChange(event){
    if (REGISTERS[event.target.value]){
      // player = REGISTERS[event.target.value];
      player.playerWhite.isAI = true;
    } else if(event.target.value === 'CPU'){
      player.playerWhite.isAI = true;
    } else {
      player.playerWhite.isAI = false;
    }
    this.setState({playerWhiteSetting: event.target.value});
  }

  render() {
    // game startしたらplayerのselectboxを押せなくするためのスタイリングクラスを追加
    let gameStatusClassName ='';
    if(this.state.items.gameState === "init"){
      gameStatusClassName = 'player-select';
    } else {
      gameStatusClassName = 'player-select player-select--game-start';
    }

    // CPUを選択した時にinputフォームのクラスを動的に変更して表示非表示を行う
    let pathInputBlackClass="path-input -hidden";
    let pathInputWhiteClass="path-input -hidden";
    if(this.state.playerBlackSetting == "CPU" ) {
      pathInputBlackClass="path-input";
    }
    if(this.state.playerWhiteSetting == "CPU" ) {
      pathInputWhiteClass="path-input";
    }

    return (
      <div>
        <header className="header">
          <div className="header__inner">
            <div className="header-branding">
              <h1 className="header-branding__text">Nulab Othello</h1>
            </div>
            <nav></nav>
          </div>
        </header>
        <main className="main">
          <div className="container">
            <div className="player">
              <div className="player-item player-item--black">
                <p className="player-black">先攻</p>
                {
                  <div className={gameStatusClassName}>
                    <div className="player-select__inner">
                      <select value={this.state.playerBlackSetting} onChange={this.playerBlackSettingChange.bind(this)}>
                        <option value="人間">人間</option>
                        <option value="CPU">CPU</option>
                        {
                          Object.keys(REGISTERS).map(key => <option value={key}>{key}</option>)
                        }
                      </select>
                    </div>
                    <input className={pathInputBlackClass} type="text" name="atext" placeholder="URL"
                      value={this.state.urlBlack}
                      onChange={(e) => this.setState({urlBlack: e.target.value})}/>
                  </div>
                  }
              </div>
              <div>
                {
                  // ゲームをリセットさせる
                  (this.state.items.gameState === "win-white" || this.state.items.gameState === "win-black" || this.state.items.gameState === "draw" || this.state.items.white.placeableCells.length === 0 && this.state.items.black.placeableCells.length === 0 && this.state.items.gameState != "init" )
                  ? <button className="button button--secondary" onClick={() => {
                    this.store.dispatch(Othello.ActionCreator.reset());
                  }}>リセット</button>
                  : null
                }
              </div>
              <div className="player-item player-item--white">
                <p className="player-white">後攻</p>
                {
                  <div className={gameStatusClassName}>
                    <div className="player-select__inner">
                      <select value={this.state.playerWhiteSetting} onChange={this.playerWhiteSettingChange.bind(this)}>
                        <option value="人間">人間</option>
                        <option value="CPU">CPU</option>
                        {
                          Object.keys(REGISTERS).map(key => <option value={key}>{key}</option>)
                        }
                      </select>
                    </div>
                    <input className={pathInputWhiteClass} type="text" name="atext" placeholder="URL"
                    value={this.state.urlWhite}
                    onChange={(e) => this.setState({urlWhite: e.target.value})}/>
                  </div>
                }
              </div>
            </div>
            <div className="game-display">

              {
                // ゲームをスタートさせる
                (this.state.items.gameState === "init")
                ? <div className="modal">
                    <button className="button button--primary" onClick={() => {
                      console.log("this.state.playerWhiteSetting", this.state.playerWhiteSetting);
                      if (REGISTERS[this.state.playerBlackSetting]) {
                        cpuPlayerBlack = REGISTERS[this.state.playerBlackSetting];
                      } else if (this.state.playerBlackSetting=='CPU') {
                        let pathBlack = this.state.urlBlack;
                        if(pathBlack==''){
                          pathBlack = 'https://leotakeishi.com/js/dynamic.js';
                        }
                        window.nativeImport(pathBlack).then(
                          (module) => {
                            cpuPlayerBlack = module.Player;
                            console.log(cpuPlayerBlack.foo(),'Ok');
                          }
                        ).catch(err => {
                          //  エラー処理
                          console.log('エラーです',err,err.stacktrace);
                        });
                      }
                      if (REGISTERS[this.state.playerWhiteSetting]) {
                        cpuPlayerWhite = REGISTERS[this.state.playerWhiteSetting];
                      } else if(this.state.playerWhiteSetting=='CPU') {
                        let pathWhite = this.state.urlWhite;
                        if(pathWhite==''){
                          pathWhite = 'https://leotakeishi.com/js/dynamic.js';
                        }
                        window.nativeImport(pathWhite).then(
                          (module) => {
                            cpuPlayerWhite = module.Player;
                            console.log(cpuPlayerWhite.foo(),'Ok');
                          }
                        ).catch(err => {
                          //  エラー処理
                          console.log('エラーです',err,err.stacktrace);
                        });
                      }

                      this.store.dispatch(Othello.ActionCreator.startGame()); }}>スタート</button>
                  </div>
                : (this.state.items.gameState === "win-black")
                ? <div className="modal"><span className="result">黒の勝利</span></div>
                : (this.state.items.gameState === "win-white")
                ? <div className="modal"><span className="result">白の勝利</span></div>
                : (this.state.items.gameState === "draw")
                ? <div className="modal"><span className="result">引き分け</span></div>
                : null
              }

              <div className="board">
                {
                  this.state.items.board.map((row,y) => {
                    return row.map((cell,x) => {
                      let className = "";
                      (cell === -1)
                      ? className = 'board__item -black'
                      : (cell === 0)
                      ? className = 'board__item'
                      : className = 'board__item -white'

                      //　置けるマスのnav 兼 パスだった場合は相手にgemeStateを変更
                      if (this.state.items.gameState=="black") {
                        if(this.state.items.black.placeableCells.length==0){
                          this.state.items.gameState="white";
                        }

                        this.state.items.black.placeableCells.find((pcell) => {
                          if(pcell.x==x && pcell.y==y) {
                            className = 'board__item -nav -black';
                            if(player.playerBlack.isAI == true){
                              className = 'board__item -nav -black -cpu';
                            }
                            return true;
                          }
                        })

                      } else if (this.state.items.gameState=="white") {
                        if(this.state.items.white.placeableCells.length==0){
                          this.state.items.gameState="black";
                        }
                        this.state.items.white.placeableCells.find((pcell) => {
                          if (pcell.x==x && pcell.y==y) {
                            className = 'board__item -nav -white';
                            if(player.playerWhite.isAI == true){
                              className = 'board__item -nav -white -cpu';
                            }
                            return true;
                          }
                        })
                      }

                      return <div className={className} onClick={(event) => this.playerAction(event,x,y)}><span className="stone"></span></div>

                    })
                  })
                }
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default Main;

